import { render, staticRenderFns } from "./coverAnnounce.vue?vue&type=template&id=15019a38&scoped=true&"
import script from "./coverAnnounce.vue?vue&type=script&lang=js&"
export * from "./coverAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./coverAnnounce.vue?vue&type=style&index=0&id=15019a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15019a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15019a38')) {
      api.createRecord('15019a38', component.options)
    } else {
      api.reload('15019a38', component.options)
    }
    module.hot.accept("./coverAnnounce.vue?vue&type=template&id=15019a38&scoped=true&", function () {
      api.rerender('15019a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/announcement/components/coverAnnounce.vue"
export default component.exports